import { Provider } from '@angular/core';
import { IconSet, NB_ICONS } from './icon.types';

/**
 * Register a set of Lucide icons for string-based `<nb-icon name="…">` lookup.
 * Tree-shakeable: only the icons you import are bundled.
 *
 * @example
 * import { House, Bell, Plus } from 'lucide';
 * providers: [provideNbIcons({ House, Bell, Plus })]
 * // template: <nb-icon name="house" /> <nb-icon name="bell" />
 *
 * The lookup key is the icon's kebab-case name (the same string the mockups use
 * in `data-lucide`), derived automatically from the PascalCase export name.
 */
export function provideNbIcons(...sets: IconSet[]): Provider[] {
  return sets.map((set) => ({ provide: NB_ICONS, useValue: normalizeKeys(set), multi: true }));
}

/** PascalCase / camelCase keys → kebab-case so `Bell`/`ChevronRight` resolve as `bell`/`chevron-right`. */
function normalizeKeys(set: IconSet): IconSet {
  const out: Record<string, IconSet[string]> = {};
  for (const [key, node] of Object.entries(set)) {
    out[toKebab(key)] = node;
  }
  return out;
}

function toKebab(name: string): string {
  return name
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1-$2')
    .toLowerCase();
}
